import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="body"
export default class extends Controller {
  static targets = ['modalAction']

  modalActionTargetConnected (_event) {
    this.hideModal()
  }

  hideModal (event) {
    if (event) {
      event.preventDefault()
    }

    document.body.dispatchEvent(new CustomEvent('modal:hide'))
  }

  confirmFormPopover (event) {
    event.preventDefault()

    document.body.dispatchEvent(new CustomEvent('popover:hide'))
    document.body.dispatchEvent(new CustomEvent('popover:confirmed'))
  }

  closePopover (event) {
    event.preventDefault()

    document.body.dispatchEvent(new CustomEvent('popover:hide'))
  }

  showModal (event) {
    event.preventDefault()

    const url = event.target.closest('a').getAttribute('href')

    if (url) {
      document.body.dispatchEvent(new CustomEvent('modal:show', {
        detail: { url }
      }))
    }
  }
}
